import { useMediaQuery } from '@mui/material';
import React from 'react';
import BrandclubSideWidget from '../components/BrandclubSideWidget/index.js';
import { TABLET_SCREEN_SIZE } from '../../utils/constants/Constants.js';

var BrandclubShopRetailers = function (_a) {
    var paragraph = _a.paragraph, LinkComponent = _a.LinkComponent, brandEntity = _a.brandEntity;
    var desktopView = useMediaQuery("(min-width:".concat(TABLET_SCREEN_SIZE, "px)"));
    return (React.createElement(BrandclubSideWidget, { leftSideProps: {
            type: 'text',
            title: 'Shop any way you choose',
            subtitle: paragraph,
            buttonText: '',
            buttonLink: { id: '', displayName: '' },
        }, rightSideProps: {
            type: 'image',
            imageUrl: "https://media.brandclub.com/brand_custom/".concat(brandEntity === null || brandEntity === void 0 ? void 0 : brandEntity.id, "/d1.png"),
            imageLink: { id: '', displayName: '' },
            imageStyle: {
                transform: "scale(".concat(desktopView ? 1.12 : 1, ")"),
            },
        }, LinkComponent: LinkComponent }));
};

export { BrandclubShopRetailers };
//# sourceMappingURL=index.js.map
